import React from "reactn"
import { Box, Button, } from "@chakra-ui/react"
// import ColorPicker from "./colorPicker";
import { ZoomImage } from "./imgZoom";
// import { chakra, shouldForwardProp } from '@chakra-ui/react';
// import { motion, isValidMotionProp } from 'framer-motion';

const ImageAndZoom = ({ scarf, section = 1, name = "Front", select, value = 1 }) => {
  console.log("IMAGEAND", scarf)
  let src = scarf.colourGarment1 ? scarf.colourGarment1 : scarf.garmentLink1
  // let src = scarf.imageLink ? scarf.imageLink : scarf.imageLink
  if (section == 2) {
    src = scarf.colourGarment2 ? scarf.colourGarment2 : scarf.garmentLink2
  } else if (section == 3) {
    src = scarf.colourGarment3 ? scarf.colourGarment3 : scarf.garmentLink3
  }

  return (
    <Box onClick={() => select(section)}>
      <Box>{name}</Box>
      <ZoomImage zoom={false} src={src} alt={'Design your own garment'} hasHeight={false} width="100%" />
      <Button variant={value == section ? 'aidesignSelected' : 'aidesign'} marginLeft={0}
        
      >{value == section ? 'SELECTED' : 'CHANGE COLOUR'} </Button>
    </Box>
  )
}


export default ImageAndZoom
